import React from 'react';
import { UserFileShowView } from '../../../types/uploadedFiles';
import { DescriptionOutlined } from '@material-ui/icons';
import { ByteUtils } from '../../../../commonv3/utils/bytes';
import './simpleUploadedFileSummary.module.scss';

type InnerProps = {
    file: UserFileShowView;
};

export const OtherFileInner = ({ file }: InnerProps) => {
    return (
        <div styleName="normal-file-wrapper">
            <DescriptionOutlined styleName="file-icon" />
            <div styleName="file-summary">
                <a styleName="file-name" href={file.url} target="_blank">
                    {file.filename}
                </a>
                <div styleName="file-size">{ByteUtils.formatBytes(file.byte_size)}</div>
            </div>
        </div>
    );
};

export const ImageFileInner = ({ file }: InnerProps) => {
    return (
        <div styleName="image-file-wrapper">
            <img styleName="img" src={file.url} />
        </div>
    );
};

export const UploadedFileInner = ({ file }: InnerProps) => {
    if (file.content_type.startsWith('image/png') || file.content_type.startsWith('image/jpeg')) {
        return <ImageFileInner file={file} />;
    } else {
        return <OtherFileInner file={file} />;
    }
};

type Props = {
    file: UserFileShowView;
};

export const SimpleUploadedFileSummary = ({ file }: Props) => {
    return (
        <div styleName="summary-wrapper" data-file-token={file.token}>
            <UploadedFileInner file={file} />
        </div>
    );
};
